export interface CancellableError extends Error {
  isCanceled: boolean
}

export const cancellableError = new Error('The promise was canceled') as CancellableError

cancellableError.isCanceled = true
